export function SysGen(fieldID) {
  var sysGen =
    fieldID == "ID" ||
    fieldID == "Orphan" ||
    fieldID == "TopOfSubChart" ||
    fieldID == "Locked" ||
    fieldID == "Persist";
  return sysGen;
}
